//include 9

jQuery(function(){

    var privateFunctions = {

    };

    $("[data-dynamic-filters]").each(function () {
        var $this = $(this);
        var containerName = $this.data("dynamic-filters");
        if (!containerName)
            return;
        var container = $(`[data-dynamic-filters-container='${containerName}']`);
        if (container.length == 0)
            return;

    });

});